export default "__VITE_PUBLIC_ASSET__cd23e790__"